var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Tally Alias",
      prop: "tallyAlias"
    }
  }, [_c("el-input", {
    attrs: {
      name: "tallyAlias",
      required: "",
      placeholder: "Tally Alias"
    },
    model: {
      value: _vm.formData.tallyAlias,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "tallyAlias", $$v);
      },
      expression: "formData.tallyAlias"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Number",
      prop: "mobileNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "mobileNumber",
      placeholder: "Mobile Number"
    },
    model: {
      value: _vm.formData.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mobileNumber", $$v);
      },
      expression: "formData.mobileNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Code",
      prop: "code"
    }
  }, [_c("el-input", {
    attrs: {
      name: "code",
      placeholder: "Branch Code"
    },
    model: {
      value: _vm.formData.code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "code", $$v);
      },
      expression: "formData.code"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Equivalent Dealer",
      prop: "equivalentDealerId"
    }
  }, [_c("el-select", {
    staticClass: "filter-item dealer-select",
    staticStyle: {
      width: "40%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Search Dealer"
    },
    model: {
      value: _vm.formData.equivalentDealerId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "equivalentDealerId", $$v);
      },
      expression: "formData.equivalentDealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Tally Identifier",
      prop: "tallyIdentifier"
    }
  }, [_c("el-input", {
    attrs: {
      required: "",
      placeholder: "Enter Tally Identifier"
    },
    model: {
      value: _vm.formData.tallyIdentifier,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "tallyIdentifier", $$v);
      },
      expression: "formData.tallyIdentifier"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Line 1",
      prop: "line1"
    }
  }, [_c("el-input", {
    attrs: {
      required: "",
      placeholder: "Enter address"
    },
    model: {
      value: _vm.formData.line1,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "line1", $$v);
      },
      expression: "formData.line1"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Line 2",
      prop: "line2"
    }
  }, [_c("el-input", {
    attrs: {
      required: "",
      placeholder: "Enter address"
    },
    model: {
      value: _vm.formData.line2,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "line2", $$v);
      },
      expression: "formData.line2"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "State"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Select State"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.formData.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "stateId", $$v);
      },
      expression: "formData.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "City"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.formData.stateId,
      clearable: "",
      filterable: "",
      placeholder: "Select City"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.formData.cityId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "cityId", $$v);
      },
      expression: "formData.cityId"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      label: "Enter Pincode",
      prop: "pincodeId",
      required: ""
    }
  }, [_vm.formData.isEditable === true ? [_c("el-select", {
    attrs: {
      filterable: "",
      remote: "",
      "remote-method": _vm.getPincodeList,
      placeholder: "Enter Pincode Name",
      disabled: _vm.formData.isEditable === false && true
    },
    model: {
      value: _vm.formData.pincodeId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "pincodeId", $$v);
      },
      expression: "formData.pincodeId"
    }
  }, _vm._l(_vm.pincodeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.pincode,
        value: item.id
      }
    });
  }), 1)] : [_c("el-input", {
    attrs: {
      placeholder: "Pincode Name"
    },
    model: {
      value: _vm.formData.pincode.pincode,
      callback: function ($$v) {
        _vm.$set(_vm.formData.pincode, "pincode", $$v);
      },
      expression: "formData.pincode.pincode"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "GST Number",
      prop: "gstNumber"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.gstNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gstNumber", $$v);
      },
      expression: "formData.gstNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PAN Number",
      prop: "panNumber"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.panNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "panNumber", $$v);
      },
      expression: "formData.panNumber"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };